import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Step from './Step';

const StepsNav = ({
  steps, activeId, header, onActivate,
}) => {
  const stepComponents = steps.length
    ? steps.map(step => (
      <Step
        className="step"
        key={step.id}
        id={step.id}
        name={step.name}
        locked={step.locked}
        completed={step.completed}
        onActivate={onActivate}
        active={activeId === step.id}
      />
    ))
    : null;

  return (
    <div className="steps-nav">
      {header && <h2>{header}</h2>}
      {stepComponents}
    </div>
  );
};

StepsNav.defaultProps = {
  activeId: '',
  header: '',
  onActivate: noop,
};

StepsNav.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeId: PropTypes.string,
  header: PropTypes.string,
  onActivate: PropTypes.func,
};

export default StepsNav;



// WEBPACK FOOTER //
// ./src/components/steps/StepsNav.js